module.exports = __webpack_public_path__ + "images/videoCaseStudy-icon-sync.svg?h=83745e1f9808d4b953583b1d3b868791";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/videoCaseStudy-icon-sync.svg
// module id = 2047
// module chunks = 12 15